<svelte:head>

    <title>Mitglieder • Ämtler-Bon Admin</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Members from "../components/screens/members.svelte";

</script>

<SessionManager />

<section>

    <Members />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        height: inherit;
        margin-left: 31vh;
    }

</style>
